import { Button, Icon } from '@graftcode/design-system'

import { useExpandedCategories } from '../../hooks/useExpandedCategories'
import type { MobileNavigationState } from '../../hooks/useMobileNavigation'
import type { TutorialSection } from '../../types'

import { HomeNavItems } from './HomeNavItems'

import styles from '../../../../MobileMenu.module.scss'

type AcademyNavigationProps = {
  nav: MobileNavigationState
  tutorialSections: TutorialSection[]
  currentTutorialPath?: string
}

export function AcademyNavigation({ nav, tutorialSections, currentTutorialPath }: AcademyNavigationProps) {
  const { expandedCategories, toggleCategory } = useExpandedCategories({
    currentTutorialPath,
    isDocumentationPage: nav.isDocumentationPage,
    documentationCategoryTree: nav.documentationCategoryTree,
    quickStartCategoryTree: nav.quickStartCategoryTree,
  })

  return (
    <div className={styles.academyMainNavigation}>
      {nav.isSubpage && (
        <Button
          variant="ghost"
          size="l"
          fullWidth
          icon={Icon.ArrowLeftRegular}
          text="Back to Home"
          onClick={() => nav.handleNavigationClick('/')}
          className={styles.academyBackToHome}
        />
      )}

      <HomeNavItems
        nav={nav}
        onNavigationClick={nav.handleNavigationClick}
        tutorialSections={tutorialSections}
        currentTutorialPath={currentTutorialPath}
        expandedCategories={expandedCategories}
        onToggleCategory={toggleCategory}
      />
    </div>
  )
}
